// src/components/common/ResetFiltersButton/ResetFiltersButton.jsx
import { useDispatch } from "react-redux";
import { Button, Tooltip } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { resetFilters } from "../../../redux/slices/filtersSlice";

const ResetFiltersButton = ({ onReset }) => {
  const dispatch = useDispatch();

  const handleReset = () => {
    dispatch(resetFilters());
  };

  return (
    <Tooltip title="Reset Filters">
      <Button
        variant="outlined"
        size="small"
        startIcon={<FilterAltOffIcon />}
        onClick={handleReset}
        sx={{
          height: "32px",
          fontSize: "13px",
          border: "none",
          color: "#555",
          textTransform: "none",
          "&:hover": {
            borderColor: "#2589f5",
            color: "#2589f5",
            background: "transparent",
          },
        }}
      />
    </Tooltip>
  );
};

export default ResetFiltersButton;
